var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyInisdeblank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.55 17.4065C8.92033 17.4065 8.38375 17.1848 7.94025 16.7413C7.49675 16.2978 7.275 15.7612 7.275 15.1315V3.275C7.275 2.64533 7.49675 2.10875 7.94025 1.66525C8.38375 1.22175 8.92033 1 9.55 1H18.4065C19.0362 1 19.5728 1.22175 20.0163 1.66525C20.4598 2.10875 20.6815 2.64533 20.6815 3.275V15.1315C20.6815 15.7612 20.4598 16.2978 20.0163 16.7413C19.5728 17.1848 19.0362 17.4065 18.4065 17.4065H9.55ZM9.55 15.1315H18.4065V3.275H9.55V15.1315ZM5.275 21.6815C4.64533 21.6815 4.10875 21.4598 3.66525 21.0163C3.22175 20.5728 3 20.0362 3 19.4065V6.4125C3 6.09333 3.10975 5.82392 3.32925 5.60425C3.54892 5.38475 3.81833 5.275 4.1375 5.275C4.45667 5.275 4.72608 5.38475 4.94575 5.60425C5.16525 5.82392 5.275 6.09333 5.275 6.4125V19.4065H15.269C15.5882 19.4065 15.8576 19.5163 16.0773 19.7358C16.2968 19.9554 16.4065 20.2248 16.4065 20.544C16.4065 20.8632 16.2968 21.1326 16.0773 21.3523C15.8576 21.5718 15.5882 21.6815 15.269 21.6815H5.275Z",
    fill: "#4C4948"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyInisdeblank);
export default __webpack_public_path__ + "static/media/copy_inisdeblank.826d136cff265fd4b73a47656d94c4bb.svg";
export { ForwardRef as ReactComponent };